<div class="title">Connected Components</div>
<ul id="groupMenu">
  <li class="menuItem" *ngFor="let c of activeGroup" (click)="openCompInfo.emit(c)">{{c.name}}</li>
</ul>